/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Pricing_Users_Count_OtherInputs */



/**
* | output |
* | --- |
* | "{count} Users" |
*
* @param {Pricing_Users_Count_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_users_count_other = /** @type {((inputs: Pricing_Users_Count_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Users_Count_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Nutzer`)
	return /** @type {LocalizedString} */ (`${i?.count} Users`)
});